import React from 'react';

import clsx from 'clsx';

interface SectionFieldHeroProps {
  className: string;
  imageSrc?: string;
  name: string;
  onClick?: () => void;
  state?: 'default' | 'selected';
}

export const SectionFieldHero: React.FC<SectionFieldHeroProps> = ({
  className,
  imageSrc,
  name,
  onClick,
  state = 'default',
}) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'group relative h-28 w-56 cursor-pointer overflow-hidden rounded-md border outline-2 outline-offset-[-1px] transition-all',
        state === 'selected'
          ? 'border-transparent outline-indigo-500'
          : 'border-neutral-100 outline-transparent hover:border-transparent hover:outline-indigo-500',
        className,
      )}
      data-name={name}
    >
      {imageSrc && (
        <img
          className="block h-auto w-full max-w-full object-cover transition-all duration-300"
          src={imageSrc}
          alt={name || 'image'}
        />
      )}
      {/* Hover overlay */}
      <div className="pointer-events-none absolute inset-0 rounded-md bg-indigo-600 opacity-0 transition-all duration-300 group-hover:opacity-25" />
    </div>
  );
};
